import * as types from './actionTypes';

export function addShareCountSuccess(shareType, shareCount) {
  return { type: types.ADD_SHARE_COUNT_SUCCESS, shareType, shareCount };
}

export function getShareCounts() {
  // We do it this way to make sure we don't include and URL params or hashes from anchor links
  const url = `${location.protocol}//${location.host}${location.pathname}`;

  const facebookShareCount = new Promise((resolve) => {
    fetch(`https://graph.facebook.com/?ids=${url}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((res) => {
        const shareCount = res[url].share.share_count;
        resolve(shareCount);
      });
    })
    .catch((error) => {
      throw (error);
    });
  });

  const twitterShareCount = new Promise((resolve) => {
    fetch(`https://public.newsharecounts.com/count.json?url=${url}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((res) => {
        const shareCount = res.count;
        resolve(shareCount);
      });
    })
    .catch((error) => {
      throw (error);
    });
  });

  return function(dispatch) {
    facebookShareCount
      .then((shareCount) => {
        dispatch(addShareCountSuccess('facebook', shareCount));
      });

    twitterShareCount
      .then((shareCount) => {
        dispatch(addShareCountSuccess('twitter', shareCount));
      });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/shareActions.js